import { render, staticRenderFns } from "./FormComponent.vue?vue&type=template&id=15ec5cb1&"
import script from "./FormComponent.vue?vue&type=script&lang=js&"
export * from "./FormComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormComponent.vue?vue&type=style&index=0&id=15ec5cb1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports